module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "frame"
    }
  }, [_c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('PageHeader'), _vm._v(" "), _c('Carousel'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('PageFooter')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cda0377", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cda0377","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/global/frame/frame.component.html
// module id = 269
// module chunks = 1